var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PostsList',{attrs:{"resource":_vm.resource,"columns":_vm.headers,"title":"Список НАШИХ УСЛОВИЙ ДОСТАВКИ ГРУЗОВ","add-route":{ name: 'terms-post' },"store":"termsPosts","path":"terms"}})}
var staticRenderFns = []

export { render, staticRenderFns }